import React, { FC, useCallback, useContext, useEffect, useState } from 'react';

import { Table, TableBody, Paper } from '@material-ui/core';

import { GlobalContext } from '../../../../../../store';
import { IEventEnrollment } from '../../../../../../store/admin/eventEnrollments/store';

import { StyledContestSetupTable } from './ContestSetupTable.Styles';
import { ContestSetupTableHead } from './Components/ContestSetupTableHead';
import { useContestSetupDispatch, useContestSetupState } from '../../Context/ContestSetup.context';
import { ContestSetupTableRow } from './Components/ContestSetupTableRow';
import { useEventRegisteredPlayers } from './useEventRegisteredPlayers.hook';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

const ContestSetupTable: FC = () => {
  const {
    actions: {
      loader: { start: startLoader, end: endLoader }
    },
    adminEventEnrollments,
    adminEventTeams,
    adminEventRounds: { current: round }
  } = useContext(GlobalContext);

  const { playerLookupValue, selectedMetaFormat, selectedLeaderboard } = useContestSetupState();

  const { clubId, eventId, roundId } = useRouteInfoState();

  const {
    actions: { updateEnrollments }
  } = useContestSetupDispatch();

  const [eventRegisteredPlayers] = useEventRegisteredPlayers({
    adminEventEnrollments,
    adminEventTeams,
    eventId,
    round
  });

  const [eventEnrollments, setEventEnrollments] = useState<IEventEnrollment[]>([]);

  const [filteredEnrollments, setFilteredEnrollments] = useState<IEventEnrollment[]>([]);

  useEffect(() => {
    if (eventRegisteredPlayers.length > 0) {
      setEventEnrollments(eventRegisteredPlayers);
    }
  }, [eventRegisteredPlayers]);

  useEffect(() => {
    if (eventEnrollments.length > 0) {
      setFilteredEnrollments(
        eventEnrollments.filter(enrollment =>
          `${enrollment.user.firstName} ${enrollment.user.lastName}`
            .toLowerCase()
            .includes(playerLookupValue.toLowerCase())
        )
      );
    }
  }, [eventEnrollments, playerLookupValue]);

  const handleSelectAllClick = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      if (selectedLeaderboard) {
        startLoader();

        await updateEnrollments(
          Number(clubId),
          Number(eventId),
          Number(roundId),
          selectedLeaderboard.id,
          event.target.checked ? eventEnrollments.map(n => n.id) : []
        );

        endLoader();
      }
    },
    [clubId, roundId, eventId, selectedLeaderboard, eventEnrollments, startLoader, endLoader]
  );

  return (
    <StyledContestSetupTable>
      {!!selectedMetaFormat && eventEnrollments.length > 0 ? (
        <Paper className="contest-selector-table-container">
          <Table
            className="contest-selector-table-container-table"
            aria-labelledby="tableTitle"
            size={'medium'}
            aria-label="enhanced table"
          >
            <ContestSetupTableHead
              onSelectAllClick={handleSelectAllClick}
              rowCount={eventEnrollments.length}
            />

            <TableBody>
              {filteredEnrollments.map((enrollment: IEventEnrollment, index) => (
                <ContestSetupTableRow key={index} enrollment={enrollment} />
              ))}
            </TableBody>
          </Table>
        </Paper>
      ) : (
        <h2>Please, select a contest</h2>
      )}
    </StyledContestSetupTable>
  );
};

export default ContestSetupTable;
